// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _2G_xY{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _2G_xY{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}._3q1A3{background:#f5f9ff;border-radius:50%;height:24px;padding:.2rem;position:relative;width:24px}._3q1A3 svg{fill:#30a8ff;height:16px;height:1.6rem;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:16px;width:1.6rem}", ""]);
// Exports
exports.locals = {
	"relatedData": "_3q1A3",
	"fading": "_2G_xY"
};
module.exports = exports;
